import { simplApi } from '../../api/simplApi';
import handleApiError from '../../helpers/handleApiError';

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_LIMITS = 'REQUEST_LIMITS';
export const RECEIVE_LIMITS = 'RECEIVE_LIMITS';

// ------------------------------------
// Actions
// ------------------------------------
export function requestLimits() {
  return {
    type: REQUEST_LIMITS,
  };
}

export function receiveLimits(limits) {
  return {
    type: RECEIVE_LIMITS,
    payload: {
      limits,
    },
  };
}

export const fetchLimits = () => dispatch => {
  dispatch(requestLimits());

  const url = 'limits';

  return simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        dispatch(handleApiError(json));
      } else {
        dispatch(receiveLimits(json));
      }
    });
};

export const actions = {
  requestLimits,
  receiveLimits,
  fetchLimits,
};

const NOTE_ACTION_HANDLERS = {
  [REQUEST_LIMITS]: state => ({
    ...state,
    fetching: true,
  }),
  [RECEIVE_LIMITS]: (state, action) => ({
    ...state,
    limits: Object.assign({}, state.limits, action.payload.limits),
    fetching: false,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  limits: {
    activities: 0,
    activitiesLeft: 1000,
    activitiesUsed: 0,
    companies: 0,
    companiesLeft: 1000,
    companiesUsed: 1,
    name: '',
    persons: 0,
    personsLeft: 1000,
    personsUsed: 0,
    projects: 0,
    projectsLeft: 1000,
    projectsUsed: 0,
    quota: 52428800,
    quotaLeft: 52428800,
    quotaUsed: 0,
    quotaUsedHuman: '0 B',
    staff: 0,
    staffLeft: 1000,
    staffUsed: 0,
    users: 1,
    usersLeft: 1000,
    usersUsed: 1,
  },
};
export default function noteReducer(state = initialState, action) {
  const handler = NOTE_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/limits.js